<div class="mb-2 mat-title-small">{{ 'catalog.settings.detail_title' | transloco }}</div>

<div class="flex flex-col gap-2">
  <mat-slide-toggle (change)="tabsLockedChange.emit($event.checked)" [checked]="tabsLocked"
                    class="primary-slide-toggle">
    {{ 'catalog.settings.detail_lock' | transloco }}
  </mat-slide-toggle>

  <mat-slide-toggle (change)="compactHeaderChange.emit($event.checked)" [checked]="compactHeader"
                    class="primary-slide-toggle">
    {{ 'catalog.settings.detail_compact_header' | transloco }}
  </mat-slide-toggle>
</div>
